import React from 'react';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../shared/components/CardBody';
import Paginator from '../../../shared/components/Paginator';
import { ContractorSearchRequest } from './contractor-search/ContractorSearchRequest';
import { ContractorSearchTask } from './contractor-search/ContractorSearchTask';
import { PsContractor } from '../PsContractor';
import { ContractorListTable } from './ContractorListTable';
import PropTypes from 'prop-types';

export class ContractorListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            loading: false,
            collapsed: props.initialCardState.collapsed,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        this.listContractors();
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { search, collapsed } = this.state;

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }
    }

    render() {
        const {
            data,
            error,
            search,
            loading,
            collapsed,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_CONTRATISTAS').toUpperCase()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={false}
                                searchText={search}
                                onRefresh={this.listContractors}
                                onSearch={this.search}
                                collapsed={collapsed}
                                onCollapsed={this.collapse}
                            />
                        )}
                    />
                    {
                        !collapsed ? (
                            <CardBody>
                                <ContractorListTable
                                    data={data}
                                    error={error}
                                />
                                <Paginator
                                    data={pagination}
                                    onPage={this.selectPage}
                                />
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    search = (search) => {
        this.setState({ search, page: 1 }, this.listContractors);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listContractors);
    };

    listContractors = () => {
        const { page, search } = this.state;
        const request = new ContractorSearchRequest();

        request.setPage(page);
        request.setTerm(search);

        new ContractorSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsContractor.fromAPIContractors(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}

ContractorListCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object,
};

ContractorListCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
        collapsed: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/list/ContractorListCard.jsx